// Microsoft Clarity configuration
export const CLARITY_PROJECT_ID = 'rtrrg3sax2'; // Add your Clarity project ID here

// Clarity tracking code
export const initClarity = () => {
  (function(c,l,a,r,i,t,y){
    c[a]=c[a]||function(){(c[a].q=c[a].q||[]).push(arguments)};
    t=l.createElement(r);t.async=1;t.src="https://www.clarity.ms/tag/"+i;
    y=l.getElementsByTagName(r)[0];y.parentNode.insertBefore(t,y);
  })(window, document, "clarity", "script", CLARITY_PROJECT_ID);
}; 